import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { Account } from '../../model/account';
import { Stat } from '../../model/stat';
import { NavParams } from 'ionic-angular';

import { StatsMorePage } from './stats-more';

@Component({
    selector: 'page-stats',
    templateUrl: 'stats.html'
})
export class StatsPage {
    account: Account = new Account();

    constructor(navParams: NavParams, private nav: NavController) {
        this.account = navParams.get('account');
        console.log('account: ', this.account);
    }

    selectStat(stat: Stat) {
        this.nav.push(StatsMorePage, { stat: stat });
    }

    back() {
        this.nav.pop();
    }
}


// WEBPACK FOOTER //
// ./src/pages/stats/stats.ts